export default {
      id: "family-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#family",
      toString: function () {
        return this.url;
      }
    }